export default __webpack_public_path__ + "static/2-1137fc3ee0ceef14d1fb64046ad37914.webp";